import script from "./AdminUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUsers.vue?vue&type=script&setup=true&lang=js"

import "./AdminUsers.vue?vue&type=style&index=0&id=9315db72&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9315db72"]])

export default __exports__